import Router from './Router';

import * as Sentry from "@sentry/react";

import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';

const queryClient = new QueryClient();

Sentry.init({
  dsn: "https://4126a8ac0a85891a5c58704d3fc48c23@o4506594138390528.ingest.us.sentry.io/4507487777128448",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Router />
      </QueryClientProvider>
    </>
  )
}

export default App
